import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import httpService from 'shared/services/http.service';
import { API_CONFIG } from 'shared/constants/constants';
import { Loader } from 'shared/components/spinner/spinner';
import { Translate } from 'shared/util/translation/translate';
import localizationConstants from 'shared/util/translation/constants';
import { useWhitelabelConfigStatus } from 'shared/hooks/useWhitelabelConfigStatus';

import { IReportsBoxes } from '../interface/forecast';
import AllForecastCards from './allForecastCards';

const ForecastContainer = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [forecastList, setForecastList] = useState<IReportsBoxes>({ boxes: [], noGroup: [] });
	const { forecast_status } = useWhitelabelConfigStatus();
	const isActivePlusOriginal = forecast_status === 'active+original';

	const fetchForecastList = () => {
		setIsLoading(true);
		httpService
			.get(API_CONFIG.path.fetchReportsList)
			.then((response) => {
				setIsLoading(false);
				setForecastList(response);
			})
			.catch((err) => {
				setIsLoading(false);
				console.error('error', err);
			});
	};

	useEffect(() => {
		fetchForecastList();
	}, []);
	const navigate = useNavigate();

	const handleOnClick = useCallback((groupId: number, type: string) => {
		if (type === 'box') {
			navigate(`/forecasts/list/${groupId}`);
		} else {
			navigate(`/forecasts/data/${groupId}`);
		}
	}, []);

	return (
		<>
			{isActivePlusOriginal && (
				<h1 className='font--24px font-weight--500 line-height--30px'>
					<Translate text={localizationConstants.matflixxForecast} />
				</h1>
			)}
			{isLoading && <Loader />}
			{!isLoading && (
				<div className='forecast-list'>
					<div
						className={`d-flex flex-wrap text-align-center justify-content-center ${
							isActivePlusOriginal ? 'mb-40' : 'mb-68'
						} reports-box--wrapper`}
					>
						<AllForecastCards
							forecastList={forecastList?.boxes || []}
							className={isActivePlusOriginal ? 'reports-small--box' : 'reports--box'}
							type='box'
							handleOnClick={handleOnClick}
						/>
					</div>
					<div className={`d-flex flex-wrap text-align-center justify-content-center reports-box--wrapper`}>
						<AllForecastCards
							forecastList={forecastList?.noGroup || []}
							className={isActivePlusOriginal ? 'reports-mini-box' : 'reports-small--box'}
							type='group'
							handleOnClick={handleOnClick}
						/>
					</div>
				</div>
			)}
		</>
	);
};

export default ForecastContainer;
